// E-posta alanı için anlık "bu adres kayıtlı mı" kontrolü
import { useEffect, useState } from 'react';
import axios from 'axios';
import { Loader2, AlertCircle, CheckCircle2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const VALID = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

// original: düzenlemede mevcut adres (değişmediyse sorgulanmaz)
export const useEmailCheck = (email, { original = '', excludeUserId, excludeCompanyId, isPublic = false } = {}) => {
  const [state, setState] = useState({ status: 'idle' });
  const value = (email || '').trim().toLowerCase();
  useEffect(() => {
    if (!VALID.test(value) || value === (original || '').trim().toLowerCase()) { setState({ status: 'idle' }); return; }
    setState({ status: 'checking' });
    let alive = true;
    const t = setTimeout(() => {
      const url = isPublic ? `${API}/public/email-check` : `${API}/email-check`;
      axios.get(url, { params: { email: value, exclude_user_id: excludeUserId || undefined, exclude_company_id: excludeCompanyId || undefined } })
        .then(r => alive && setState({ status: r.data.taken ? 'taken' : 'ok', owner: r.data.owner }))
        .catch(() => alive && setState({ status: 'idle' }));
    }, 500);
    return () => { alive = false; clearTimeout(t); };
  }, [value, original, excludeUserId, excludeCompanyId, isPublic]);
  return state;
};

export const EmailCheckHint = ({ state, testId = 'email-check-hint' }) => {
  if (state.status === 'checking') return <p className="mt-1 flex items-center gap-1 text-xs text-slate-400" data-testid={`${testId}-checking`}><Loader2 className="h-3 w-3 animate-spin" />E-posta kontrol ediliyor...</p>;
  if (state.status === 'ok') return <p className="mt-1 flex items-center gap-1 text-xs text-emerald-600" data-testid={`${testId}-ok`}><CheckCircle2 className="h-3 w-3" />E-posta kullanılabilir</p>;
  if (state.status !== 'taken') return null;
  return (
    <p className="mt-1 flex items-start gap-1 text-xs font-medium text-rose-600" data-testid={testId}>
      <AlertCircle className="mt-px h-3.5 w-3.5 shrink-0" />
      <span>Bu e-posta adresi {state.owner ? <>başka bir kayda ait: <b>{state.owner}</b></> : 'sistemde kayıtlı'}. Lütfen farklı bir e-posta adresi girin.</span>
    </p>
  );
};
